import { SearchRequest } from "./common";

export interface VehicleSearchRequest
{
    SensorId: number;
}

export const requestVehicles = (searchParams?: Partial<VehicleSearchRequest>): SearchRequest => ({ ...searchParams, Name: 'Vehicles' })


// WEBPACK FOOTER //
// ./src/rest/Search/vehicles.ts